import React from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add
} from "@mui/icons-material";

import { 
  OptionalFeatureBase,
} from "@models";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";
import { makeStyles } from "@utilities/theme_utilities";

// import DisplayObjects from '../display/DisplayObjects';
// import SelectObjectBox from "../../../../components/input/selects/SelectObjectBox";

interface Props {
  parent_type: string;
  parent_id: string;
  source_book_ids: string[];
  optional_feature_bases: OptionalFeatureBase[];
  // onChange: (optional_feature_bases: OptionalFeatureBase[]) => void; 
  onExpand: (optional_feature_base: OptionalFeatureBase) => void;
  onAdd: () => void;
  disabled?: boolean;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function OptionalFeatureBasesInput({ 
  parent_type,
  parent_id,
  source_book_ids,
  optional_feature_bases,
  onExpand,
  onAdd,
  disabled = false
}: Props) {
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        '&.tableHeader': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.secondary.dark,
        },
        '&.alternate': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.dark,
        },
      },
    });
  });

  const descriptionStyle = () => {
    const descWidth = Math.floor(window.innerWidth * 0.8);
  
    const properties: React.CSSProperties = {
      width: `${descWidth}px`,
      whiteSpace: "nowrap", 
      overflow: "hidden", 
      textOverflow: "ellipsis"
    } as React.CSSProperties;

    return properties;
  }

  const { classes, cx } = useStyles();
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Optional Feature Bases
        </span>
        { api.user && 
          (api.user.admin || 
            common_util.anyOverlaps(["",...api.user.source_book_ids], source_book_ids)) &&
          <Tooltip title={`Create New Optional Feature Base`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onAdd();
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid
        container
        spacing={0}
        direction="row"
        className={cx(classes.root, "tableHeader")}
        size={{
          xs: 12
        }}>
        <Grid
          size={{
            xs: 2
          }}>
          Name
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          Level
        </Grid>
        <Grid
          size={{
            xs: 9
          }}>
          Description
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <Grid container spacing={0} direction="row" style={{ 
            maxHeight: (window.innerHeight - 420), 
            overflowY: "auto", 
            width: "100%", 
            overflowX: "hidden",
          }}>
          { optional_feature_bases.sort((a, b) => { 
            if (a.level === b.level) {
              return a.name.localeCompare(b.name);
            } else {
              return +a.level < +b.level ? -1 : 1;
            }
          }).map((optional_feature_base, key) => {
            return (
              <Grid
                key={key}
                container
                spacing={0}
                direction="row"
                onClick={() => {
                  onExpand(optional_feature_base);
                }}
                className={cx(classes.root, (key % 2 === 1 ? "alternate" : "" ))}
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 2
                  }}>
                  { optional_feature_base.name === "" ? "Nameless Optional Feature Base" : optional_feature_base.name }
                </Grid>
                <Grid
                  size={{
                    xs: 1
                  }}>
                  { optional_feature_base.level }
                </Grid>
                <Grid
                  size={{
                    xs: 9
                  }}>
                  <div style={descriptionStyle()}>
                    {optional_feature_base.description}
                  </div>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}
